/**
 * `Blob`をファイルとして保存する。
 * @param blob 保存する`Blob`
 * @param filename ファイル名
 */
export function saveAsFile(blob: Blob, filename: string) {
  if (Object.prototype.hasOwnProperty.call(window.navigator, "msSaveOrOpenBlob")) {
    /* Internet Explorer、Microsoft Edgeでの処理 */
    (window.navigator as any).msSaveOrOpenBlob(blob, filename);
  } else {
    /* Google Chrome、Firefoxでの処理 */
    /** Blobに紐づくオブジェクトURL */
    const url = URL.createObjectURL(blob);
    /** ダウンロードに使用する`a`要素 */
    const a = document.createElement("a");
    a.href = url;
    // ダウンロード属性を指定する。
    a.setAttribute("download", filename);
    document.body.appendChild(a);
    a.click();
    URL.revokeObjectURL(url);
    a.parentNode?.removeChild(a);
  }
}
